import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";
const { marginList, marginBackBuyer, marginDeduct, marginLog } = httpApi.margin;

interface PageSize {
  page: number;
  size: number;
}

// 保证金添加修改接口
interface MarginListParams extends PageSize {
  uid: string;
  order_num: string;
  bargain_id: string;
  status: string;
  s_time: string;
  e_time: string;
  export: number;
  field: string;
}
export const apiMarginList = (json: MarginListParams): any =>
  http.httpGet({
    url: marginList,
    json,
  });

// 退回给买家
interface MarginBackBuyerParams {
  id: string;
}
export const apiMarginBackBuyer = (json: MarginBackBuyerParams): any =>
  http.httpPost({
    url: marginBackBuyer,
    json,
  });
// 系统扣除接口
export const apiMarginDeduct = (json: MarginBackBuyerParams): any =>
  http.httpPost({
    url: marginDeduct,
    json,
  });
// 详情日志
interface MarginLogParams extends PageSize {
  id: string;
}
export const apiMarginLog = (json: MarginLogParams): any =>
  http.httpPost({
    url: marginLog,
    json,
  });
